import { createProviderRegistry } from '../createProviderRegistry'
import { agoraCloudRecordingAdapter } from './agora'

export function createRecordingProviderRegistry({ providers = [] } = {}) {
  const registry = createProviderRegistry('recording')

  ;[agoraCloudRecordingAdapter, ...providers].forEach((provider) => {
    if (provider) {
      registry.register(provider)
    }
  })

  return registry
}
